// extracted by mini-css-extract-plugin
export default {"container":"src-components-TextAlignment-style__container--8lGDO","icon":"src-components-TextAlignment-style__icon--WgRs6"};